import { render, staticRenderFns } from "./W0134V0001.vue?vue&type=template&id=c4c4de0a&scoped=true&"
import script from "./W0134V0001.vue?vue&type=script&lang=js&"
export * from "./W0134V0001.vue?vue&type=script&lang=js&"
import style0 from "./W0134V0001.vue?vue&type=style&index=0&id=c4c4de0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c4de0a",
  null
  
)

export default component.exports